export default "__VITE_ASSET__DkzUibaZ__"